import { FormArray, FormControl, FormGroup } from "@angular/forms";
import { BmExpFg, BmExpGroupFg, BmItemForm } from "../../pojo/bm-form";
import { BmExpensesCalcService } from "./bm-expenses-calc.service";
import { BmCalcHelperService } from "../general/bm-calc-helper.service";
import { BmDefaultFormCreatorService } from "../general/bm-default-form-creator.service";
import { BmExpGroup, BmItem } from "../../pojo/bm-classes";

export class BmExpensesFormService {

  public static createForm(groups: BmExpGroup[], yearsNumber: number): FormGroup<BmExpFg> {

    const sectionGroupsFA = new FormArray<FormGroup<BmExpGroupFg>>(
      groups.map((groupModel: BmExpGroup): FormGroup<BmExpGroupFg> => {
        const groupFG = BmExpensesCalcService.createExpGroupForm(groupModel);
        BmExpensesCalcService.recalculateGroupRowTotal(groupFG); // calculate row total value for each group
        return groupFG;
      })
    );
    const items: BmItem[] = BmDefaultFormCreatorService.createItemsArray(yearsNumber);

    const sectionTotalFA = new FormArray<FormGroup<BmItemForm>>(
      items.map((subGroupData: BmItem): FormGroup<BmItemForm> => BmCalcHelperService.createBmItemForm(subGroupData))
    );

    const sectionTotalRowValue = new FormControl(BmCalcHelperService.recalculateRowTotal(sectionTotalFA));

    return new FormGroup<BmExpFg>({
      groups: sectionGroupsFA,
      total: sectionTotalFA,
      totalRow: sectionTotalRowValue,
      totalRowPcnt: new FormControl<number>(0),
      showSection: new FormControl<boolean>(true),
    });
  }
}
